export const BODY_PARTS = 'bodyPart';
export const PRODUCTS = 'products';

